import { Image, StyleSheet, Text, View } from "@react-pdf/renderer";
import { drName } from "../redux/apiUrl";

// Reserve this space below the body so long documents cannot cover the signature.
export const SIGNATURE_FOOTER_SPACE = 215;

const styles = StyleSheet.create({
  block: {
    flexGrow: 1,
    flexShrink: 0,
    minHeight: 170,
    alignItems: "center",
    textAlign: "center",
    color: "#000",
  },
  images: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: 125,
    flexShrink: 0,
  },
  signature: {
    width: 106.92,
    height: 77.22,
    // Keep the signature's lower edge in place when resizing.
    marginTop: -12.22,
    flexShrink: 0,
    objectFit: "contain",
    position: "relative",
    top: 12,
  },
  stamp: {
    width: 136,
    height: 45.9,
    objectFit: "contain",
    marginTop: 6,
  },
  text: { fontFamily: "Helvetica", fontSize: 9, marginBottom: 5 },
  footer: {
    position: "absolute",
    bottom: 20,
    left: 30,
    right: 30,
    height: 195,
    flexDirection: "row",
    alignItems: "flex-end",
    gap: 20,
  },
});

export function DoctorSignatureFooter({ children }) {
  return (
    <View
      style={styles.footer}
      fixed
      render={({ pageNumber, totalPages }) =>
        pageNumber === totalPages ? children : null
      }
    />
  );
}

export default function DoctorSignature({ doctor }) {
  return (
    <View style={styles.block} wrap={false}>
      <View style={styles.images}>
        <Image src="/images/firma.png" style={styles.signature} />
        <Image src="/images/sello-schofat.png" style={styles.stamp} />
      </View>
      <Text style={styles.text}>______________________</Text>
      <Text style={styles.text}>{doctor?.printer_name || drName}</Text>
      <Text style={styles.text}>{doctor?.specialty || "Pediatría"}</Text>
    </View>
  );
}
